import { PromisePool } from "@shared/ui";
import autobind from "autobind-decorator";
import type { ReactNode } from "react";
import React from "react";
import type { LeadFormStepContainerContextType } from "./LeadFormStepContainerContext";
import { LeadFormStepContainerContext } from "./LeadFormStepContainerContext";

interface Props extends Omit<LeadFormStepContainerContextType, "activeAnim"> {
	id?: string;
}

interface State {
	activeStep: string;
	activeAnim: string;
}

export class LeadFormStepContainer extends React.Component<Props, State> {
	public static defaultProps = LeadFormStepContainerContext;
	private readonly promisePool = new PromisePool();

	public constructor(props: Props) {
		super(props);

		this.state = {
			activeStep: props.activeStep || "step-1",
			activeAnim: "",
		};
	}

	public componentDidUpdate(prevProps: Props): void {
		const { activeStep } = this.props;

		if (prevProps.activeStep !== activeStep) {
			this.onStepEvent(activeStep);
		}
	}

	public componentWillUnmount(): void {
		this.promisePool.cancel();
	}

	private getContextValue(): LeadFormStepContainerContextType {
		const { bottomLogo, previousSteps, colorScheme, stepNumber, ga4Event } = this.props;
		const { activeStep, activeAnim } = this.state;

		return {
			onStep: this.onStep,
			onChange: this.onChange,
			bottomLogo,
			previousSteps,
			colorScheme,
			activeStep,
			activeAnim,
			stepNumber,
			ga4Event,
		};
	}

	public render(): ReactNode {
		const { children, id } = this.props;

		return (
			<LeadFormStepContainerContext.Provider value={this.getContextValue()}>
				<div className="small-calculator-step-container" id={id}>
					{children}
				</div>
			</LeadFormStepContainerContext.Provider>
		);
	}

	@autobind
	protected onStep(step: string, data: Record<string, any>): void {
		const { onStep } = this.props;

		if (onStep) {
			onStep(step, data);
		}
	}

	@autobind
	protected onChange(step: string, data: Record<string, any>): void {
		const { onChange } = this.props;

		if (onChange) {
			onChange(step, data);
		}
	}

	private onStepEvent(name: string): void {
		this.setState({
			activeAnim: "animated zoomOut faster",
		});

		this.promisePool.addTimeout(250).then(() => {
			this.setState({
				activeAnim: "animated fadeIn fast",
				activeStep: name,
			});

			this.promisePool.addTimeout(400).then(() => {
				this.setState({
					activeAnim: "",
				});
			});
		});
	}
}
